import { createSelector } from 'reselect';

import { VISIBLE_ONE_LINKS_COLS_INITIAL_STATE } from '../../constants/oneLink';
import { VISIBLE_REPORTS_COLS_INITIAL_STATE } from '../../constants/reports';
import { IAppState } from '../reducers';

export const selectRootState = (state: IAppState) => state.tools;

export const selectEngagementIsLoading = createSelector(selectRootState, (tools) => (tools ? tools.isLoading : false));

export const selectReportsVisibleColumns = createSelector(selectRootState, (reports) =>
  reports ? { ...VISIBLE_REPORTS_COLS_INITIAL_STATE, ...reports.visibleReportsColumns } : {},
);

export const selectOneLinksVisibleColumns = createSelector(selectRootState, (tools) =>
  tools ? { ...VISIBLE_ONE_LINKS_COLS_INITIAL_STATE, ...tools.visibleOneLinksColumns } : {},
);

export const selectInventoryVisibleColumns = createSelector(selectRootState, (tools) =>
  tools ? tools.visibleInventoryColumns : {},
);

export const selectAddressVisibleColumns = createSelector(selectRootState, (tools) =>
  tools ? tools.visibleAddressColumns : {},
);
